import { createGlobalStyle } from 'styled-components';
import { variables } from './components/variables';

let globalStyles = '';

export function addGlobalStyle(style: string) {
    globalStyles += '\n\n' + style;
}

export const globalStyle = (style) => addGlobalStyle(style);

export const GlobalStyle = createGlobalStyle`
  .navigation-global-wrapper {
    //z-index: 2000;

    .k-panelbar {
      padding: 0 !important;
      margin: 0 !important;
    }

    .k-panelbar > .k-item > .k-link {
      display: flex !important;
    }

    .k-panelbar-collapse.k-icon, .k-panelbar-expand.k-icon{
      position: relative !important;
    }
  }
  
  body:not(.kendo-ng), body.kendo-ng {
    #zApp.z-full-screen-mode {
      .navigation-global-wrapper {
        left: 20px !important;
      }
    }
      
    .top-menu-dropdown__popup {
      padding: 24px 0 !important;
    }

    ${() => globalStyles}
  }
`;
